import TokenInput from "../../common/TokenInput";
import { CgPassword } from "react-icons/cg";

const TokenStep = ({
  email,
  token,
  setToken,
  isLoading,
  onSubmit,
  onResend,
}: TokenStepProps) => (
  <form onSubmit={onSubmit} className="w-full space-y-4">
    <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
      <CgPassword className="text-2xl text-center text-white" />
    </div>
    <div className="space-y-2">
      <h1 className="text-2xl text-center font-bold text-gray-7">
        Enter Verification Code
      </h1>
      <p className="text-gray-6 text-center">
        Enter the 6-digit code we sent to {email}.
      </p>
    </div>
    <div className="flex justify-center mb-8">
      <TokenInput value={token} onChange={setToken} />
    </div>
    <button
      type="submit"
      disabled={isLoading || token.length !== 6}
      className="w-full px-4 py-2 text-white bg-gray-7 rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? "Verifying..." : "Verify Email"}
    </button>
    <button
      type="button"
      onClick={onResend}
      className="w-full px-4 py-2 text-black rounded-lg border border-gray-7 hover:bg-gray-2 hover:text-white focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
    >
      {isLoading ? "Resending..." : "Resend Code"}
    </button>
  </form>
);

export default TokenStep;

interface TokenStepProps {
  email: string;
  token: string;
  setToken: (token: string) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onResend: () => Promise<void>;
}
